/* eslint-disable */
import type { LocalizableString } from "../cash/localization/localization.pb";
import type { AppVersion } from "../franklin/common.pb";

export enum DocumentCategory {
  ROOT = "ROOT",
  /** LENDING_INSTALLMENT_PLANS - Buy Now Pay Later */
  LENDING_INSTALLMENT_PLANS = "LENDING_INSTALLMENT_PLANS",
  STATEMENTS = "STATEMENTS",
  /** BANKING_STATEMENTS - Sub-categories of STATEMENTS. */
  BANKING_STATEMENTS = "BANKING_STATEMENTS",
  /**
   * INVESTMENT_STATEMENTS - Deprecated, we'll have separate categories for Stocks and Bitcoin when needed
   *
   * @deprecated
   */
  INVESTMENT_STATEMENTS = "INVESTMENT_STATEMENTS",
  BORROW = "BORROW",
  /** STOCK_TAX_FORM - Tax forms related to stock trading. */
  STOCK_TAX_FORM = "STOCK_TAX_FORM",
  /** STOCK_MONTHLY_STATEMENT - Monthly summary of activity related to stock trading. */
  STOCK_MONTHLY_STATEMENT = "STOCK_MONTHLY_STATEMENT",
  /** BUSINESS - Cash for Business documents */
  BUSINESS = "BUSINESS",
  /** BTC_TAX_FORM - Annual BTC Consolidated 1099B */
  BTC_TAX_FORM = "BTC_TAX_FORM",
  /** BUSINESS_TAX_FORMS - Cash for Business tax forms (sub category of BUSINESS) */
  BUSINESS_TAX_FORMS = "BUSINESS_TAX_FORMS",
}

/**
 * Version information to control visibility of the document or category.
 * Versions are inclusive.
 */
export interface VersionData {
  min_android_version?: AppVersion;
  max_android_version?: AppVersion;
  min_ios_version?: AppVersion;
  max_ios_version?: AppVersion;
}

/** SyncEntity data for a document category. */
export interface DocumentCategoryEntity {
  /** The category this configuration defines. */
  category?: string;
  /** The parent category for this category. */
  parent_category?: string;
  /** The name to display for the category. */
  display_name?: string;
  /** Order for the category on client. */
  order?: number;
  /** Rendering style for the category. */
  render_style?: DocumentCategoryEntityRenderStyle;
  /** Version information used to restrict visibility of the item if required. */
  version_data?: VersionData;
  /** Localizable field for DocumentCategoryEntity.display_name */
  localizable_display_name?: LocalizableString;
}

/** Rendering style of the elements in the category. */
export enum DocumentCategoryEntityRenderStyle {
  /** INVALID - Invalid state - proto deserializer may default to this if the value is unknown. */
  INVALID = "INVALID",
  /** REVERSE_CHRONO_LIST - Documents displayed in reverse chronological order, no date separators. */
  REVERSE_CHRONO_LIST = "REVERSE_CHRONO_LIST",
  /** CATEGORY_LIST_BY_PRIORITY - List of categories ordered by priority. */
  CATEGORY_LIST_BY_PRIORITY = "CATEGORY_LIST_BY_PRIORITY",
  /** REVERSE_CHRONO_LIST_BY_YEAR - Documents displayed in reverse chronological order, with year date separators. */
  REVERSE_CHRONO_LIST_BY_YEAR = "REVERSE_CHRONO_LIST_BY_YEAR",
}

/** SyncEntity data for a document. */
export interface DocumentEntity {
  /** The category this document belongs to. */
  category?: string;
  /** The token identifying this document. */
  token?: string;
  /** The title for the document. */
  title?: string;
  /** The client route for the document. */
  client_route?: string;
  /** The URL used to retrieve the document. */
  url?: string;
  /** Version information used to restrict visibility of the item if required. */
  version_data?: VersionData;
  /**
   * The token of the customer who owns this document. This will be used by clients to determine
   * where to put this document, especially for Cash customers that sponsor accounts for teens
   * will need to see the statements for those custodial accounts.
   */
  owner_token?: string;
  /** Localizable field for DocumentEntity.title */
  localizable_title?: LocalizableString;
}

/** Non SyncEntity version of a document */
export interface Document {
  /** The category this document belongs to. */
  category?: string;
  /** The token identifying this document. */
  token?: string;
  /** The title for the document. */
  title?: string;
  /** The URL used to retrieve the document. */
  url?: string;
  /**
   * The token of the customer who owns this document. This will be used by clients to determine
   * where to put this document, especially for Cash customers that sponsor accounts for teens
   * will need to see the statements for those custodial accounts.
   */
  owner_token?: string;
  /** The date that this document is covering, in epoch ms. */
  document_date?: number;
}
